import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_CONFIRM } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';
import { APPOINTMENT_CONFIRMED_SUCCESS } from '../../constants/messages';

export function* appointmentConfirm(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(APPOINTMENT_CONFIRM, call(appointmentAPI.confirm, params), appointmentSchema);
    yield toastr.success('Success', APPOINTMENT_CONFIRMED_SUCCESS);
  } catch (e) {
    yield put(error(APPOINTMENT_CONFIRM, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_CONFIRM));
    yield put(push('/reps/calendar'));
    if (params.redirectUrl) {
      yield put(push('/reps/calendar'));
    }
  }
}

export function* watchAppointmentConfirm() {
  yield takeEvery(APPOINTMENT_CONFIRM, appointmentConfirm);
}

export default function* root() {
  yield all([
    fork(watchAppointmentConfirm)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentConfirm.js